export default "__VITE_ASSET__HaBPamou__"